"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaPreview = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const useObjectUrl_1 = require("./useObjectUrl");
const imgClass = (0, nano_theme_1.rule)({
    display: 'block',
    maxW: '100%',
    maxH: '480px',
    bdrad: '6px',
    bxz: 'border-box',
});
const mediaClass = (0, nano_theme_1.rule)({
    display: 'block',
    w: '100%',
    bdrad: '6px',
    bxz: 'border-box',
});
const MediaPreview = ({ thing, kind }) => {
    const url = (0, useObjectUrl_1.useObjectUrl)(thing.data, thing.mimeType);
    if (!url)
        return null;
    if (kind === 'image') {
        return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
            React.createElement("img", { className: imgClass, src: url, alt: thing.name || 'image' })));
    }
    // biome-ignore lint/a11y/useMediaCaption: caption track is unavailable for user-uploaded media
    if (kind === 'video')
        return React.createElement("video", { className: mediaClass, src: url, controls: true });
    // biome-ignore lint/a11y/useMediaCaption: caption track is unavailable for user-uploaded media
    return React.createElement("audio", { className: mediaClass, src: url, controls: true });
};
exports.MediaPreview = MediaPreview;
